import type { BoxProps} from '@mui/material'
import {Box, colors, Container, styled} from '@mui/material'

export const Scroller = styled('div', {
  name: 'Scroller',
  slot: 'Root'
})(({theme}) => ({
  [theme.breakpoints.up('md')]: {
    height: '100vh',
    overflowY: 'scroll',
    scrollSnapType: 'y mandatory',
    scrollBehavior: 'smooth'
  }
}))


interface SectionProps extends BoxProps {
  backgroundVideo?: string
}

export function Section({children, backgroundVideo, ...boxProps}: SectionProps) {
  if (backgroundVideo) {
    return <SectionBox className="video-bg" {...boxProps}>
      <video className="SectionBbx-background" autoPlay loop muted playsInline>
        <source src={backgroundVideo}/>
      </video>
      {children}</SectionBox>
  }
  return <SectionBox><Container maxWidth="md">{children}</Container></SectionBox>
}

const SectionBox = styled(Box, {
  name: 'SectionBox',
  slot: 'Root'
})(({theme}) => ({
  '&:nth-of-type(even):not(.video-bg), &:nth-of-type(even):not(.form)': {
    backgroundColor: colors.indigo[900],
    '& .MuiTypography-root': {
      color: theme.palette.common.white
    }
  },
  '& .MuiContainer-root': {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  [theme.breakpoints.up('md')]: {
    width: '100vw',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'scroll',
    scrollSnapAlign: 'start'
  },
  position: 'relative',
  '& video.SectionBbx-background': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: -1
  }
}))
